export const SET_CURRENT_STEP = 'SET_CURRENT_STEP';
export const SET_NEXT = 'SET_NEXT';
export const SET_NEXT_STEP = 'SET_NEXT_STEP';
export const SET_LATER = 'SET_LATER';
export const ONBOARDING_RESUME = 'ONBOARDING_RESUME';
export const CLEAR_STEP_PROCESS = 'CLEAR_STEP_PROCESS';
